export const EDITOR_ADDONS = [
  "highlight",
  "emoji",
  "video-upload",
  "code-block",
  "block-quote",
  "image-upload",
  "image-upload-unsplash",
  "divider",
  "video-embed",
  "undo",
  "redo",
  "table",
  "callout",
];

export const DEFAULT_EDITOR_PROPS = {
  isMenuIndependent: true,
  addons: [],
  size: "medium",
};

export const IMAGE_UPLOAD_CONFIG = {
  maxImageSize: 1,
  allowedImageTypes: {
    "image/jpg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/svg": [".svg"],
  },
};
